import React, {Component} from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import { Col, Container, Row, Alert } from 'reactstrap';
import TestUserList from '../TestUserList';
import {FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';
import { connect } from 'react-redux';
import { getAuthToken } from '../../../store/utility';

import EinbeinstandErgebnisInput from './EinbeinstandErgebnisInput';

class Einbeinstand extends Component {
    state = {
        showSaveButton: true,
        showSuccessAlert: false,
        einbeinstandErgebnisse: [],
        EinbeinstandErgebnis: [0,0,0,0],
        ButtonsDisabled: [false, true, true, true]
    }

    componentWillReceiveProps() {
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'Einbeinstand/GetEinbeinstandErgebnisseOfTest?pTestID=' + this.props.testID, { headers: { 'Authorization': `Bearer ${token}`}})
            .then(response => {
                this.setState({
                    einbeinstandErgebnisse: response.data
                });
            });
    }
    
    componentDidMount() {
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'Einbeinstand/GetEinbeinstandErgebnisseOfTest?pTestID=' + this.props.testID, {headers: {'Authorization': `Bearer ${token}`}})
            .then(response => {
                this.setState({
                    einbeinstandErgebnisse: response.data
                });
            });
    }

    EinbeinstandErgebnisChangedHandler = (uebung, value) => {
        let newEinbeinstandErgebnis = [...this.state.EinbeinstandErgebnis];
        newEinbeinstandErgebnis[uebung - 1] = parseInt(value, 10);
        this.setState({
            EinbeinstandErgebnis: newEinbeinstandErgebnis
        });
    }

    activeTeilnehmerChangedHandler = (selected) => {
        let newEinbeinstandErgebnis = [0, 0];
        this.setState({
            EinbeinstandErgebnis: newEinbeinstandErgebnis,
            showSaveButton: true,
            showSuccessAlert: false
        });
        this.props.changed(selected);
    }

    saveEinbeinstandErgebnis = () => {
        const data = [...this.state.EinbeinstandErgebnis];
        axios.post(this.props.apiUri + 'Einbeinstand?pKindID=' + this.props.activeTeilnehmerID + '&pTestID=' + this.props.testID + '', data, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                axios.get(this.props.apiUri + 'Einbeinstand/GetEinbeinstandErgebnisseOfTest?pTestID=' + this.props.testID, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                    .then(response => {
                        this.setState({
                            einbeinstandErgebnisse: response.data,
                            showSaveButton: false,
                            showSuccessAlert: true
                    });
                }) 
            })
    }

    render() {

        let showSaveButton = this.state.showSaveButton;
        let showSuccessAlert = this.state.showSuccessAlert;
        let einbeinstandErgebnisse = [...this.state.einbeinstandErgebnisse];
        let balancierenAnleitung = (
            <div>
                <p>Hier bitte Ergebnisse eintragen.</p>
            </div>
        );
        

        let einbeinstandTeilnehmer = [...this.props.testUsers];
        einbeinstandTeilnehmer.forEach(function (testUser) {
            if (einbeinstandErgebnisse.length > 0 && einbeinstandErgebnisse.some(ergebnis => ergebnis.kindID === testUser.id)) {
                testUser.uebungAbsolviertSymbol = <FaCheckCircle size={16} />;
                testUser.uebungAbsolviert = "JA";
            }
            else {
                testUser.uebungAbsolviert = "NEIN";
                testUser.uebungAbsolviertSymbol = "";
            }
        });

        let index = [...this.props.selected];
        if (einbeinstandTeilnehmer !== undefined && einbeinstandTeilnehmer[index[0]] !== undefined) {
            if (einbeinstandTeilnehmer[index[0]].uebungAbsolviert === "JA") {
                showSaveButton = false;
            }
        }

        let einbeinstandErgebnisInput = null;
        let saveEinbeinstandErgebnisButton = null;
        if (showSaveButton) {
            einbeinstandErgebnisInput = (
                <div>
                    <EinbeinstandErgebnisInput
                        EinbeinstandErgebnis={this.state.EinbeinstandErgebnis}
                        onChange={(versuch, value) => this.EinbeinstandErgebnisChangedHandler(versuch, value)}
                    />
                </div>
            );

            saveEinbeinstandErgebnisButton = (
                <div><button
                    className="btn btn-primary"
                    onClick={() => this.saveEinbeinstandErgebnis()}
                    type="button"> Ergebnis speichern
                </button>
                </div>
            );
        }
        else {
            let currentUserEinbeinstandErgebnis = einbeinstandErgebnisse.filter(ergebnis => ergebnis.kindID === this.props.activeTeilnehmerID)
            const style = {
                display: 'block ruby',
                padding: '10px'
            };
            if (currentUserEinbeinstandErgebnis.length > 0) {
                einbeinstandErgebnisInput = (
                    <div>
                        <h4>Gespeicherte Ergebnisse</h4>
                        <h5 style={style}>Links: {currentUserEinbeinstandErgebnis[0].links}</h5>
                        <h5 style={style}>Rechts: {currentUserEinbeinstandErgebnis[0].rechts}</h5>
                    </div>
                );
            }
        }

        if (showSuccessAlert) {
            saveEinbeinstandErgebnisButton = (
                <Alert color="success">Einbeinstand Ergebnis von {this.props.activeTeilnehmerVorname} wurde gespeichert!</Alert>
            );
        }

        return (
            <div>
                <Container>
                    <Row>
                        <Col xs="3">
                            <TestUserList
                                id="EinbeinstandTestUser"
                                testUsers={einbeinstandTeilnehmer}
                                selected={this.props.selected}
                                changed={(selected) => { this.activeTeilnehmerChangedHandler(selected) }} />
                        </Col>
                        <Col>
                            <h3>{this.props.activeTeilnehmerVorname} führt Einbeinstand durch:</h3>
                            {balancierenAnleitung}
                            {einbeinstandErgebnisInput}
                            {saveEinbeinstandErgebnisButton}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        apiUri: state.apiUri,
        token: state.token,
        username: state.username
    };
  };

export default connect(mapStateToProps)(Einbeinstand);